import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ApiJwtService {

    constructor(private http: HttpClient) { }

    read(url: string, options: object = {}): Promise<any> {
        return this.http.get<any>(url, options).toPromise();
    }

    createUpdateDelete(url: string, data: object): Promise<any> {
        return this.http.post<any>(url, data).toPromise();
    }

}
